<template>
  <div>
    <!-- 头部切换栏 -->
    <div class="box">
      <div>
        <span :class="radio == 32 ? 'index active' : 'index'" @click="gotoIndex">首页</span>
        <span :class="radio == 33 ? 'advertisement active' : 'advertisement'" @click="gotoAdver">广告收入明细</span>
        <span :class="'advertisement'" @click="onToV2Click">广告收入（新老用户）</span>
        <!-- <span :class="radio==41?'advertisement active':'advertisement'" @click="gotoMember">会员收入明细</span> -->
        <span :class="radio == 43 ? 'advertisement active' : 'advertisement'" @click="gotoV2">会员收入明细</span>
        <span :class="radio == 42 ? 'advertisement active' : 'advertisement'" @click="gotoPackage">套餐复购情况</span>
      </div>
      <div v-show="radio != 43">
        <el-button @click="dialogVisible = true" class="margin-top">模块设置</el-button>
      </div>
    </div>
    <!-- 模块设置的弹窗 -->
    <el-dialog :title="DashboardSetting.basename" @close="resumeDashboardSetting" :visible.sync="dialogVisible"
      width="30%">
      <el-checkbox-group v-model="checkList">
        <el-checkbox v-for="(v, i) in DashboardSetting.children" :label="v.id" :key="i">{{ v.basename }}</el-checkbox>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resumeDashboardSetting">取 消</el-button>
        <el-button type="primary" @click="saveBoardSetting">确 定</el-button>
      </span>
    </el-dialog>

    <Index v-if="radio == 32" ref="index" :checkList="changeCheckList" />
    <Advertisement v-if="radio == 33" ref="index" :checkList="changeCheckList" />
    <Newadvertisement v-if="radio == 44" ref="index" :checkList="changeCheckList" />
    <!-- <MemberDetails v-if="radio == 41" ref="index" :checkList="changeCheckList" /> -->
    <PackageF v-if="radio == 42" ref="index" :checkList="changeCheckList" />
    <V2 v-if="radio == 43" />
  </div>
</template>

<script>
import Index from './component/index.vue'
import Advertisement from './component/advertisement.vue'
// import MemberDetails from './component/memberdetails.vue'
import PackageF from './component/packageF.vue'
import V2 from './component/v2/index.vue'
import { goNewSys } from '@/util/index'
export default {
  data() {
    return {
      radio: 32,
      changeCheckList: [],
      checkList: [],
      dialogVisible: false,
      DashboardSetting: [],
    }
  },
  components: {
    Index,
    Advertisement,
    // MemberDetails,
    PackageF,
    V2,
  },
  mounted() {
    this.getDashboardSetting()
  },
  methods: {
    gotoIndex() {
      if (this.radio == 32) {
        return
      }
      this.radio = 32
      this.getDashboardSetting()
    },
    gotoAdver() {
      if (this.radio == 33) {
        return
      }
      this.radio = 33
      this.getDashboardSetting()
    },
    /* gotoMember(){
     if (this.radio == 41) {
        return
      }
      this.radio = 41
      this.getDashboardSetting()
    }, */
    gotoPackage() {
      if (this.radio == 42) {
        return
      }
      this.radio = 42
      this.$nextTick(() => {
        this.$refs.index.getDashboardSetting()
      })

    },
    gotoV2() {
      if (this.radio == 43) {
        return
      }
      this.radio = 43
    },
    // 点击前往新系统
    onToV2Click() {
      goNewSys({
        path: '/business/commercialize'
      })
    },
    // 获取到的是头部模块设置和分栏的相关数据(商业化报表首页)
    async getDashboardSetting() {
      const [err, res] = await this.$http.post('Business/dashboardSetting', {
        pid: this.radio,
      })
      if (err) return
      let checkList = []
      this.DashboardSetting = res
      res.children.forEach((item) => {
        if (item.clicked == 1) {
          checkList.push(item.id)
        }
      })
      // changeCheckList中存放的是头部模块设置每一项的id
      this.changeCheckList = [...checkList]
      this.checkList = [...checkList]
      this.$refs.index.getDashboardSetting()
    },
    // 取消模板设置
    resumeDashboardSetting() {
      this.checkList = [...this.changeCheckList]
      this.dialogVisible = false
      // this.radio == 41 ? this.$refs.index.getOrderPlan():this.$refs.index.fetchCount()
      // this.radio == 41 ? this.$refs.index.getOrderPay():this.$refs.index.getReport()
      this.radio == 32 ? this.$refs.index.funnelEach() : ''
    },
    // 保存模板设置
    async saveBoardSetting() {
      const [err, res] = await this.$http.post('Business/saveBoardSetting', {
        setting_ids: this.checkList,
        pid: this.radio,
      })
      if (err) return
      this.changeCheckList = [...this.checkList]
      this.dialogVisible = false
      // this.radio == 41 ? this.$refs.index.getOrderPlan():this.$refs.index.fetchCount()
      // this.radio == 41 ? this.$refs.index.getOrderPay():this.$refs.index.getReport()
      this.radio == 32 ? this.$refs.index.funnelEach() : ''
    },
  },
}
</script>

<style lang="less" scoped>
.radio_button {
  width: 75px;
}

.box {
  background-color: #fff;
  margin: 20px 0;
  display: flex;
  justify-content: space-between;

  span {
    display: inline-block;
    padding: 15px 0 12px 0;
    font-size: 16px;
    color: rgba(90, 92, 96, 0.65);
    cursor: pointer;
  }

  .index {
    margin: 0 60px 0 18px;
  }

  .advertisement {
    margin-right: 60px;
  }

  .active {
    font-size: 16px;
    font-weight: bold;
    color: #232528;
    border-bottom: 2px solid #ff981f;
  }

  .margin-top {
    margin-top: 5px;
  }
}
</style>